import { useQueryClient } from "@tanstack/react-query";
import { useCallback } from "react";
import useLocales from "src/hooks/useLocales";
import { getOrgAppsRequest } from "src/services/organizations/queries/apps";
import { getUserSettingsRequest } from "src/services/user/queries/settings";
import { AppType } from "src/types/apps";
import { User } from "src/types/user";

export default function useFetchInitialData() {
	const queryClient = useQueryClient();
	const { onChangeLang } = useLocales();

	const fetchInitialData = useCallback(async () => {
		// Fetch user
		const user: User = await getUserSettingsRequest();

		queryClient.setQueryData(["user"], () => ({ ...user }));

		// Fetch apps
		if (user && user.organization && user.organization.id !== "") {
			onChangeLang(user.language);
			const apps: AppType[] = await getOrgAppsRequest(user.organization.id);
			queryClient.setQueryData(["apps"], () => [...apps]);
			const appSelected = queryClient.getQueryData<string>(["apps", "selected"]);
			if (!appSelected || appSelected === "")
				queryClient.setQueryData(["apps", "selected"], apps[0] ? apps[0].id : "");
		}
	}, []);

	return { fetchInitialData };
}
